// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-container {
  width: 100%;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.item-container:hover {
  transform: translateY(-2px);
}

.item-content {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.item-image-wrapper {
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
}
@media (min-width: 991px) {
  .item-image-wrapper {
    width: 120px;
    height: 120px;
  }
}

.item-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item-name {
  font-family: AppFont;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 0;
}
@media (min-width: 991px) {
  .item-name {
    font-size: 20px;
    line-height: 26px;
  }
}

.item-description {
  font-family: AppFont;
  font-size: 12px;
  font-weight: 300;
  line-height: 19px;
  color: var(--randy-gray);
  margin: 0;
  opacity: 0.8;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-tags {
  display: flex;
  gap: 5px;
  align-items: center;
}
.item-tags app-tag {
  margin: 0;
}

.item-actions {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.item-price {
  font-family: AppFont;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: var(--randy-gray);
  margin: 0;
  white-space: nowrap;
}

.add-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid var(--randy-gray);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: all 0.2s ease;
}
.add-button ion-icon {
  font-size: 20px;
  color: var(--randy-gray);
}
.add-button:hover {
  background: var(--randy-red);
  border-color: var(--randy-red);
}
.add-button:hover ion-icon {
  color: white;
}

.item-container:not(:has(.item-image-wrapper)) .item-content {
  padding-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,eAAA;EACA,+BAAA;AADD;AAGC;EACC,2BAAA;AADF;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,2CAAA;AAFD;;AAKA;EACC,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAFD;ACtBE;EDmBF;IAQE,YAAA;IACA,aAAA;EADA;AACF;;AAIA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AADD;;AAIA;EACC,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AADD;;AAIA;EACC,oBAAA;EACA,eAAA;EACG,gBAAA;EACH,iBAAA;EAEA,SAAA;AAFD;ACxDE;EDoDF;IASE,eAAA;IACA,iBAAA;EADA;AACF;;AAIA;EACC,oBAAA;EACA,eAAA;EACG,gBAAA;EACH,iBAAA;EACA,wBAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AADD;;AAIA;EACC,aAAA;EACA,QAAA;EACA,mBAAA;AADD;AAGC;EACC,SAAA;AADF;;AAKA;EACC,cAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;AAFD;;AAKA;EACC,oBAAA;EACA,eAAA;EACG,gBAAA;EACH,iBAAA;EACA,wBAAA;EACA,SAAA;EACA,mBAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;AAFD;AAIC;EACC,eAAA;EACA,wBAAA;AAFF;AAKC;EACC,4BAAA;EACA,8BAAA;AAHF;AAKE;EACC,YAAA;AAHH;;AAUC;EACC,eAAA;AAPF","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\n.item-container {\n\twidth: 100%;\n\tcursor: pointer;\n\ttransition: transform 0.2s ease;\n\t\n\t&:hover {\n\t\ttransform: translateY(-2px);\n\t}\n}\n\n.item-content {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n\tpadding-bottom: 10px;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.item-image-wrapper {\n\tflex-shrink: 0;\n\twidth: 100px;\n\theight: 100px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n\t\n\t@include desktop {\n\t\twidth: 120px;\n\t\theight: 120px;\n\t}\n}\n\n.item-image {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.item-details {\n\tflex: 1;\n\tmin-width: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.item-text {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4px;\n}\n\n.item-name {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n    font-weight: 500;\n\tline-height: 24px;\n\t// color: var(--randy-gray);\n\tmargin: 0;\n\t\n\t@include desktop {\n\t\tfont-size: 20px;\n\t\tline-height: 26px;\n\t}\n}\n\n.item-description {\n\tfont-family: AppFont;\n\tfont-size: 12px;\n    font-weight: 300;\n\tline-height: 19px;\n\tcolor: var(--randy-gray);\n\tmargin: 0;\n\topacity: 0.8;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 2;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.item-tags {\n\tdisplay: flex;\n\tgap: 5px;\n\talign-items: center;\n\t\n\tapp-tag {\n\t\tmargin: 0;\n\t}\n}\n\n.item-actions {\n\tflex-shrink: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tgap: 8px;\n}\n\n.item-price {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n    font-weight: 500;\n\tline-height: 24px;\n\tcolor: var(--randy-gray);\n\tmargin: 0;\n\twhite-space: nowrap;\n}\n\n.add-button {\n\twidth: 30px;\n\theight: 30px;\n\tborder-radius: 50%;\n\tborder: 1px solid var(--randy-gray);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: transparent;\n\ttransition: all 0.2s ease;\n\t\n\tion-icon {\n\t\tfont-size: 20px;\n\t\tcolor: var(--randy-gray);\n\t}\n\t\n\t&:hover {\n\t\tbackground: var(--randy-red);\n\t\tborder-color: var(--randy-red);\n\t\t\n\t\tion-icon {\n\t\t\tcolor: white;\n\t\t}\n\t}\n}\n\n// Handle items without images\n.item-container:not(:has(.item-image-wrapper)) {\n\t.item-content {\n\t\tpadding-left: 0;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
